// extracted by mini-css-extract-plugin
export default {"gif":"d_r","gif--wrapped":"d_s"};